import React from "react";
import type { PropsWithChildren } from "react";
import type { IconProps } from "../icons/icon";

export type SearchSectionButton = {
  icon?: React.ComponentType<IconProps>;
  text: string;
  href: string;
  onClick?: () => void;
};

type SearchSectionProps = PropsWithChildren<{
  icon?: React.ComponentType<IconProps>;
  title?: string;
  subtitle?: string;
  meta: string;
  button?: SearchSectionButton;
}>;

export default function SearchSection({ icon: Icon, title, subtitle, meta, children, button }: SearchSectionProps) {
  return (
    <div className={`dewey--search--section dewey--search--section--${meta}`}>
      <div className="dewey--search--section--header">
        {Icon && <Icon className="dewey--search--section--icon" />}
        {title && <p className={`dewey--search--section--title dewey--search--section--${meta}--title`}>{title}</p>}
        {subtitle && (
          <p className={`dewey--search--section--subtitle dewey--search--section--${meta}--subtitle`}>{subtitle}</p>
        )}
      </div>

      <div className={`dewey--search--section--content dewey--search--section--${meta}--content`}>
        <ul className={`dewey--search--section--list dewey--search--section--${meta}--list`}>{children}</ul>
      </div>

      {button && (
        <a
          className="dewey--search--section--button"
          href={button.href}
          onClick={button.onClick}
        >
          {button.icon && (
            <button.icon
              height={20}
              width={20}
            />
          )}
          {button.text}
        </a>
      )}
    </div>
  );
}
